import {GuardianBase, GuardianUploadPayloadData} from './type'

export function mapGuardianApiToFormData(data: GuardianBase): GuardianUploadPayloadData {
  return {
    parent_id: data.parent_id,
    mobile: data.parent_mobile || '',
    user_status: data.parent_user_status,
    name: data.parent_name || '',
    email: data.parent_email || '',
    gender: data.parent_gender || '',
    dob: data.parent_dob || '',
    country: data.parent_country || '',
    whatsapp: data.parent_whatsapp || '',
    identification_id: data.parent_identification_id || '',
    address: data.parent_address || '',
    country_code: data.parent_country_code,
  }
}
